import { MenuBadgeCountKey } from '@/app/config/menuBadgeCountKey';
import { usePendingChecklistsCount } from '@/app/modules/checklist/core/_hooks';
import { useNewTrainingsCount } from '@/app/modules/trainings/core/_hooks';
import { useWaitingTicketsCount } from '@/app/modules/tickets/core/_hooks';

export type MenuBadgeCounts = Record<MenuBadgeCountKey, number>;

export function useMenuBadgeCounts(): MenuBadgeCounts {
  const waitingTicketsCount = useWaitingTicketsCount();
  const pendingChecklistsCount = usePendingChecklistsCount();
  const newTrainingsCount = useNewTrainingsCount();
  return {
    [MenuBadgeCountKey.WAITING_TICKETS]: waitingTicketsCount,
    [MenuBadgeCountKey.PENDING_CHECKLISTS]: pendingChecklistsCount,
    [MenuBadgeCountKey.NEW_TRAININGS]: newTrainingsCount,
  };
}
